import { useEffect, useRef, useState } from 'react';

// Only run decorative animations while the sprite and its tab are visible.
export default function useVisibleSprite() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    let inView = true;
    const update = () => setVisible(inView && document.visibilityState !== 'hidden');
    const observer = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(([entry]) => {
      inView = entry.isIntersecting;
      update();
    }) : null;
    if (ref.current) observer?.observe(ref.current);
    document.addEventListener('visibilitychange', update);
    update();
    return () => {
      observer?.disconnect();
      document.removeEventListener('visibilitychange', update);
    };
  }, []);
  return [ref, visible];
}
